import { RequiredRule, Validator } from 'devextreme-react/validator';
import { DateBox } from 'devextreme-react/date-box';
import { useContext } from 'react';
import { Field, Panel } from '../../../../layouts';
import { AR, OrderStatus } from '../../../../types/enums';
import { PurchaseOrderContext } from '../context/PurchaseOrderContext';
import { formatShortDate } from '../../../../utils/date-utils';

export default function EnterServiceDatePanel() {

	const { order, modifyOrder } = useContext(PurchaseOrderContext);

	const isOrderReadonly = order.details.orderStatusID === OrderStatus.Closed ||
		order.details.orderStatusID === OrderStatus.Cancelled ||
		order.details.orderStatusID === OrderStatus.Pending;

	const isReadOnly = !order.details.activeARs.includes(AR.POServiceProviderToEnterServiceDate) || isOrderReadonly;
	const isRequired = !isReadOnly;

	return (
		<Panel header={'Dates'} >
			<Field label="Order Date">
				{formatShortDate(order.details.retailOrder.roDate)}
			</Field>
			<Field label="Template Date">
				{formatShortDate(order.details.retailOrder.enterTemplateDate)}
			</Field>
			<Field label="Scheduled Install Date">
				{formatShortDate(order.details.retailOrder.scheduledInstallDate)}
			</Field>
			<Field label="Actual Install Date">
				{formatShortDate(order.details.retailOrder.actualInstallDate)}
			</Field>
			<Field label="Service Initiated Date" >
				<DateBox value={order.details.serviceInitiatedDate}
					onValueChanged={(e) => modifyOrder({ ...order.details, serviceInitiatedDate: e.value })}
					readOnly={isReadOnly}
					className={isRequired ? 'required' : ''}>
					<Validator>
						{
							isRequired && order.modified &&
							<RequiredRule message={'Service Initiated Date is required'} />
						}
					</Validator>
				</DateBox>
			</Field>
		</Panel>
	);
}
